import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import Button0 from './Button0/Button0';
import Button1 from './Button1/Button1';
import Button3 from './Button3/Button3';
import ButtonPay from './ButtonPay/ButtonPay';
import ButtonSubscribe1 from './ButtonSubscribe1/ButtonSubscribe1';
import ButtonSubscribe2 from './ButtonSubscribe2/ButtonSubscribe2';

export default memo(({ soft, info = {}, logInfo = {} }) => {
  useEffect(() => {}, []);
  return (
    <React.Fragment>

      {(!soft.androidType || soft.androidType === '0') &&
        soft.payType === 1 &&
        (!soft.appBizType || soft.appBizType === 0) && (
          <ButtonPay soft={soft} info={info} logInfo={logInfo}></ButtonPay>
        )}
      {(!soft.androidType || soft.androidType === '0') &&
        soft.payType !== 1 &&
        (!soft.appBizType ||
          soft.appBizType === 0 ||
          (soft?.appBizType !== 0 && !soft?.appBizContent)) && (
          <Button0 soft={soft} info={info} logInfo={logInfo}></Button0>
        )}

      {(!soft.androidType || soft.androidType === '0') &&
        soft.appBizType === 1 &&
        soft.appBizContent && (
          <ButtonSubscribe1 soft={soft} info={info} logInfo={logInfo}></ButtonSubscribe1>
        )}
      {(!soft.androidType || soft.androidType === '0') &&
        soft.appBizType === 2 &&
        soft.appBizContent && (
          <ButtonSubscribe2 soft={soft} info={info} logInfo={logInfo}></ButtonSubscribe2>
        )}

      {soft.androidType === '1' && <Button1 soft={soft} info={info} logInfo={logInfo}></Button1>}
      {soft.androidType === '3' && <Button3 soft={soft} info={info} logInfo={logInfo}></Button3>}
    </React.Fragment>
  );
});
